import { HeadingTag, Link, ResponsiveImage, RichText } from '@/components';
import { FullPageSideElementType } from './FullPageSlideModule';
import classNames from 'classnames';

type FullPageSideElementModel = {} & FullPageSideElementType;

const FullPageSideElement = (data: FullPageSideElementModel) => {
  const {
    props: { image, cta, text, theme, title, titleHeading },
  } = data;

  return (
    <div
      className={classNames(
        'full-page-side-element flex h-full w-full',
        theme === 'Dark' ? 'module-base-dark' : 'module-base-light',
      )}
    >
      {image && (
        <div className="w-1/2">
          <ResponsiveImage
            image={image}
            widths={{ xs: 425, sm: 768, md: 200, lg: 300, xl: 400, xxl: 1000 }}
            heights={{ xs: 750, sm: null, md: null, lg: null, xl: null, xxl: null }}
          />
        </div>
      )}
      <div
        className={classNames('color-from-bg flex items-center lg:px-[90px] xl:px-[150px]', image ? 'w-1/2' : 'w-full')}
      >
        <div>
          {title && <HeadingTag tag={titleHeading} heading={title} className="mb-8" />}
          {text && <RichText data={text} />}
          {cta && <Link className="btn secondary btn-from-bg mt-10" link={cta} />}
        </div>
      </div>
    </div>
  );
};

export default FullPageSideElement;
